export const APPEND_LIST = 'APPEND_LIST';
export const GET_VIDEO_RESOURCE_LIST = 'GET_VIDEO_RESOURCE_LIST';
export const RESET_LISTS = 'RESET_LISTS'; // 重置列表
